import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const CTA_LINK = 'https://equilibradamente.base44.app/';

export default function FinalCTA() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6 relative overflow-hidden" style={{ background: '#0B1525' }}>
      {/* Glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, rgba(0,200,232,0.06) 0%, transparent 70%)' }}
      />

      <div
        ref={ref}
        className="relative z-10 max-w-2xl mx-auto text-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.8s ease, transform 0.8s ease',
        }}
      >
        {/* Decorative glow */}
        <div
          className="w-24 h-24 rounded-full mx-auto mb-8 flex items-center justify-center"
          style={{ background: 'rgba(0,200,232,0.08)', border: '1px solid rgba(0,200,232,0.2)' }}
        >
          <i className="ri-leaf-line text-4xl" style={{ color: '#3DCC78' }} />
        </div>

        <h2 className="text-3xl md:text-4xl font-semibold leading-tight mb-6 text-white">
          Comece agora sua primeira sessão gratuita
        </h2>

        <p className="text-base leading-relaxed mb-10 max-w-lg mx-auto" style={{ color: '#7A9BB5' }}>
          Um primeiro passo para conhecer seu sistema nervoso, desacelerar e iniciar um processo de reorganização emocional.
        </p>

        <a
          href={CTA_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-block whitespace-nowrap font-semibold rounded-full px-12 py-5 text-base mb-5 cursor-pointer"
          style={{
            background: 'linear-gradient(135deg, #00C8E8, #00A3C0)',
            color: '#060D18',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-3px)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 10px 40px rgba(0,200,232,0.4)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow = 'none';
          }}
        >
          Quero iniciar minha sessão gratuita
        </a>

        <p className="text-sm" style={{ color: '#3A6A85' }}>
          Sessão gratuita &nbsp;•&nbsp; Sem cartão &nbsp;•&nbsp; Duração aproximada: 15 min
        </p>
      </div>
    </section>
  );
}